import { useMutation } from "@tanstack/react-query"

import { axiosClient } from "$/http"

import Urls from "../urls"

export default function useSubmitOffboarding() {
    return useMutation({ mutationFn: (data: any) => axiosClient.post(Urls.submitOffboardingJourneyReflection(), data) })
}
